import React, { useState, useEffect,useMemo } from 'react';
import { Checkbox, Button, Input, Form, Select, App, Cascader, Upload, Modal } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import styles from './StorePublishProductStep1.module.scss';
import { getProductCategoryAllList, getProductBrandAllList, getProductSpuAllList, getProductOptionAllList } from '@/api/products';
import type { UploadProps, UploadFile, GetProp } from 'antd';
import { useAppSelector } from '@/store/hooks';
import { IFormDataAll, ISkuList } from '../../types';
import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

//prop入参类型
interface StorePublishProductStep1Props {
  onNext?: (submitData: any) => void;
  onCancel?: () => void;
  getStoreType?: (type: 'individual' | 'business') => void;
  formData?: IFormDataAll; // 使用导入的接口
  parentSkuList?: ISkuList[];
}


//级联选择器选项类型
interface CascaderOption {
  value: number;
  label: string;
  children?: CascaderOption[];
  isLeaf?: boolean;
}

//级联选择器选项类型
interface IClassification {
  is_active: boolean;
  is_delete: boolean;
  order: any;
  parent_id: number;
  product_category_id: number;
  product_category_name: string;
  child?: IClassification[];
}

//自定义属性类型
interface CustomAttribute {
  attribute_name: string;
  attribute_value: string;
}

//自定义属性配置类型
interface CustomAttributeConfig {
  attribute_name: string;
  attribute_values: string[];
}

//文件类型
type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

// 添加CheckboxGroup常量
const CheckboxGroup = Checkbox.Group;

// 产品发布第一步 - 基本信息
const StorePublishProductStep1: React.FC<StorePublishProductStep1Props> = ({
  onNext,
  onCancel,
  formData, // 接收formData属性
  parentSkuList = []
}) => {

  //message弹窗对象
  const { message } = App.useApp();


  const [form] = Form.useForm();


   //国际化语言切换
    const { t, i18n } = useTranslation();

  //获取token
  const token = useAppSelector((state) => state.user.token);



  //Main Image图片上传配置 Main Image图片上传配置

  //主图url默认回传
  const [fileList, setFileList] = useState<any[]>([
    // {
    //   uid: '-1',
    //   name: 'image.png',
    //   status: 'done',
    //   url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
    // },
  ]);

  const [fileListDel, setFileListDel] = useState<any[]>([
  
  ]);


  // 添加预览状态变量 附件查看大图配置
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  // 添加预览状态变量 附件查看大图配置

  //图片上传配置
  const ImageProps: UploadProps = {
    name: 'file',
    action: `${process.env.REACT_APP_API_URL}/api/product/save_upload_file`,
    accept: ".png,.jpeg,.jpg,.gif",
    headers: {
      //记得修改
      token: `${token}`,
    },
    listType: 'picture-card',
    maxCount: 5, // 只允许上传五个
    showUploadList: true, // 显示fileList
    fileList: fileList,
    beforeUpload: (file) => {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        message.error("Image must be smaller than 10MB!");
      }
      return isLt10M; // 返回 false 阻止上传
    },
    onChange(info) {
      //debugger
      // 复制一份文件列表
      const newFileList = [...info.fileList];

      // 对文件状态进行处理
      newFileList.forEach(file => {
        if (file.response) {
          // ✅ 保存完整的上传响应数据
          file.url = file?.response?.data?.url;
          (file as any).file_id = file?.response?.data?.file_id;  // ✅ 保存file_id
          (file as any).thumbnail = file?.response?.data?.thumbnail;  // ✅ 保存封面
          (file as any).media_type = file?.response?.data?.type;  // ✅ 保存类型
        }
      });

      // 更新状态
      setFileList(newFileList);

      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList);
      }

      if (info.file.status === 'done') {
        //完成逻辑
        // setFileList([...fileList, info.file]);
        // ✅ 如果是视频,显示转换提示
        if (info.file.response?.data?.type === 'video') {
          message.info('视频已上传,正在后台转换为MP4格式');
        }

      } else if (info.file.status === 'removed') {
        //删除逻辑

        if(!!(info.file as any)?.product_media_id ){//如果存在product_media_id，则删除

          setFileListDel([...fileListDel,{product_media_id:(info.file as any)?.product_media_id}])
          
        }
        
        
        
        setFileList([...info.fileList]);

      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    async onPreview(file: UploadFile) {
      //预览逻辑
      let src = file.url as string;
      if (!src) {
        src = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(file.originFileObj as FileType);
          reader.onload = () => resolve(reader.result as string);
        });
      }
      // 设置预览状态
      setPreviewImage(src);
      setPreviewVisible(true);
      setPreviewTitle(file.name || '图片预览');
    }
  };

  //Main Image图片上传配置 Main Image图片上传配置





  // Brand品牌相关逻辑 Brand品牌相关逻辑
  const [brandList, setBrandList] = useState<any[]>([]);

  const getBrandList = (product_category_id: number | null) => {
    getProductBrandAllList({
      product_category_id
    }).then((res) => {
      console.log(res, 'getProductBrandAllList');
      if (res.code === 200) {
        setBrandList(res.data);
      }
    });
  }

  //切换品牌
  const changeBrand = (value: number) => {
    console.log(value, 'changeBrand');
    //清空表单值
    form.setFieldValue('product_spu_id', null);
    setSelectedBrandId(value);
    getSpuList(value);

    if (selectedCascaderValue.length > 0) {
      //清空选中的sku规格值
      setSelectedSpecValues({});
      //debugger
      getOptionsList(selectedCascaderValue[selectedCascaderValue.length - 1], value);

    }

  }

  // Brand品牌相关逻辑 Brand品牌相关逻辑

  // spu相关逻辑 spu相关逻辑
  const [spuList, setSpuList] = useState<any[]>([]);
  const getSpuList = (product_category_brand_id: number) => {
    getProductSpuAllList({
      product_category_brand_id
    }).then((res) => {
      console.log(res, 'getProductSpuAllList');
      if (res.code === 200) {
        setSpuList(res.data);
      }
    });
  }

  // spu相关逻辑 spu相关逻辑

  // 获取sku属性列表相关逻辑

  // sku属性列表整合数据
  const [productSpecs, setProductSpecs] = useState<any[]>([
    // {
    //   product_base_attribute_id: 3, //属性名的Id  可以作为主键    product_base_attribute.product_base_attribute_id
    //   product_base_attribute_name: "产地",

    //   product_category_id: 1, //分类id  product_category.product_category_id
    //   product_category_name: "手机",

    //   product_category_brand_id: 1,//品牌id product_category_brand.product_category_brand_id
    //   brand_name: "Apple",

    //   product_spu_id: 1,  //spu Id   product_spu.product_spu_id
    //   product_spu_name: 'iphone 16',

    //   options: [
    //     {
    //       product_category_base_attribute_option_id: 1,
    //       option_name: 'America'
    //     }
    //   ]


    // }

  ]);


  // memo属性 用于合并自定义属性
  const [productSpecsesult , setProductSpecsesult] = useState<any[]>([

  ]);



  //选中的spu带数据 3是3是product_base_attribute_id属性名主键 后面是option_name属性名称
  const [selectedSpecValues, setSelectedSpecValues] = useState<{
    [key: number]: (string | number)[];
  }>({
    // 3: ["America"],
  });

  // 处理规格选择变化
  const handleSpecChange = (attrId: number, values: (string | number)[]) => {
    //debugger
    setSelectedSpecValues(prev => ({
      ...prev,
      [attrId]: values
    }));
  };





  //获取sku属性列表
  const getOptionsList = (product_category_id: number | null, product_category_brand_id: number | null ) => {
    getProductOptionAllList({
      product_category_id,
      product_category_brand_id
    }).then((res) => {
      console.log(res, 'getProductOptionAllList');
      if (res.code === 200) {
        const arr = res.data;
        const result: any[] = [];

        arr.forEach((item: any) => {
          const attrId = item.product_base_attribute.product_base_attribute_id;

          // 查找是否已有该属性分组
          let group = result.find(g => g.product_base_attribute_id === attrId);

          if (!group) {
            group = {
              product_base_attribute_id: attrId,
              product_base_attribute_name: item.product_base_attribute.product_base_attribute_name,

              product_category_id: item.product_category.product_category_id,
              product_category_name: item.product_category.product_category_name,

              product_category_brand_id: item.product_category_brand.product_category_brand_id,
              brand_name: item.product_category_brand.brand_name,

              product_spu_id: item.product_spu?.product_spu_id || null,
              product_spu_name: item.product_spu?.product_spu_name || null,

              options: []
            };

            result.push(group);
          }

          group.options.push({
            product_category_base_attribute_option_id: item.product_category_base_attribute_option_id,
            option_name: item.option_name
          });
        });

        console.log(result, 'result');
        if(!formData?.customize_SKU_attribute){
          setProductSpecs(result);
        }else{
          setProductSpecsesult(result);

        }
        


      }
    });
  }


 

  //生成sku列表  
  const generateSkuList = () => {

    // 准备规格值组合的笛卡尔积
    const specsArray = productSpecs.map((spec) => {
      const values = selectedSpecValues[spec.product_base_attribute_id] || [];
      return values.map((value) => ({ [spec.product_base_attribute_name]: value }));
    }).filter((item:any)=>item.length>0);

  

    console.log('specsArray', specsArray);

    // 生成笛卡尔积
    function cartesian(arr: any[]) {
      return arr.reduce(
        (acc, val) => {
          return acc.flatMap((x: any) => val.map((y: any) => ({ ...x, ...y })));
        },
        [{}]
      );
    }

    const combinations = cartesian(specsArray);

    console.log('combinations', combinations);

    const product_spu_id = form.getFieldValue('product_spu_id');

    const product_spu_name = spuList.find((item: any) => item.product_spu_id === product_spu_id)?.product_spu_name;

 

    // 检查现有SKU是否存在，如果存在则保留价格和库存
    const newSkuList = combinations.map((specs: any) => {
      // 查找是否已有相同规格的SKU
      const existingSku = parentSkuList.find((sku) => {
        return Object.keys(specs).every((key) => {
          const spec = sku.specs.find((spec: any) => spec.lable === key);
          return spec && spec.value === specs[key];
        });
      });

      if (existingSku) {
        //debugger
        return {
          ...existingSku,
          brand_name: productSpecs[0]?.brand_name || '',
          product_spu_name: productSpecs[0]?.product_spu_name || product_spu_name
        };
      } else {

        // 创建新的SKU
        return {
          brand_name: productSpecs[0]?.brand_name || '',
          product_spu_name: productSpecs[0]?.product_spu_name || product_spu_name,
          product_sku_id: null,
          product_price: 0,
          product_stock: 0,
          is_on_shelf: false,
          specs: Object.entries(specs).map(([key, value]) => {
            const product_base_attribute_id =
              productSpecs.find((item: any) => item.product_base_attribute_name === key)?.product_base_attribute_id;
            return {
              lable: key,
              value,
              product_base_attribute_id
            }
          }),
        }

      }
    });


    return newSkuList;

  }

  // 获取sku属性列表相关逻辑





  //Product Category级联选择器相关代码 Product Category级联选择器相关代码

  //级联选项
  const [cascaderOptions, setCascaderOptions] = useState<CascaderOption[]>([]);

  //级联选择器选中值
  const [selectedCascaderValue, setSelectedCascaderValue] = useState<number[]>([]);

  // 将原始分类数据转换为Cascader需要的格式
  const transformToCascaderOptions = (data: IClassification[] = []): CascaderOption[] => {
    return data.map(item => {
      const hasChildren = item.child && item.child.length > 0;
      return {
        value: item.product_category_id,
        label: item.product_category_name,
        children: hasChildren ? transformToChildrenOptions(item.child) : undefined,
        isLeaf: !hasChildren // 如果没有子分类，则标记为叶子节点
      };
    });
  };

  // 转换子分类数据
  const transformToChildrenOptions = (children: IClassification[] = []): CascaderOption[] => {
    return children.map(child => {
      const hasChildren = child.child && child.child.length > 0;
      return {
        value: child.product_category_id,
        label: child.product_category_name,
        children: hasChildren ? transformToChildrenOptions(child.child) : undefined,
        isLeaf: !hasChildren // 如果没有子分类，则标记为叶子节点
      };
    });
  };

  // 查找第一条数据的最后一个节点
  const findLastNodePath = (data: IClassification[]): number[] => {
    if (!data || data.length === 0) return [];

    const path: number[] = [];
    let currentNode = data[0]; // 第一条数据
    path.push(currentNode.product_category_id);

    // 递归查找最深的子节点
    while (currentNode.child && currentNode.child.length > 0) {
      currentNode = currentNode.child[0];
      path.push(currentNode.product_category_id);
    }

    return path;
  };

  // 根据ID查找完整路径
  const findPathById = (options: CascaderOption[], targetId: number, currentPath: number[] = []): number[] | null => {
    for (const option of options) {
      // 尝试当前路径
      const newPath = [...currentPath, option.value];

      // 如果找到目标ID
      if (option.value === targetId) {
        return newPath;
      }

      // 如果有子节点，递归查找
      if (option.children && option.children.length > 0) {
        const result = findPathById(option.children, targetId, newPath);
        if (result) {
          return result;
        }
      }
    }

    return null;
  };

  // 根据最后一级ID查询完整路径
  // const path = findPathById(cascaderOptions, 1);


  // 显示分类路径
  const displayRender = (labels: string[]): string => {
    return labels.join(' > ');
  };

  // 处理分类选择
  const handleCascaderChange = (value: any, selectedOptions: any): void => {
    console.log(value, 'value');
    console.log(selectedOptions, 'selectedOptions');

    if (selectedOptions && selectedOptions.length > 0) {
      const lastOption = selectedOptions[selectedOptions.length - 1];
      // 只有当选择的是叶子节点时才设置值
      if (lastOption.isLeaf) {
        // 保存完整路径
        setSelectedCascaderValue(value);

        //清空表单值
        form.setFieldValue('product_category_brand_id', null);
        form.setFieldValue('product_spu_id', null);
        
        //清空品牌ID和自定义属性配置
        setSelectedBrandId(null);
        setCustomSKUAttributeConfigs([]);

        //获取品牌数据
        getBrandList(lastOption.value);
      }
    }
  };




  //Product Category级联选择器相关代码 Product Category级联选择器相关代码


  // 自定义属性相关逻辑
  const [customAttributes, setCustomAttributes] = useState<CustomAttribute[]>([
    // {
    //   attribute_name: 'Lable',
    //   attribute_value: 'Value'
    // }
  ]);

  // SKU自定义属性配置相关逻辑  SKU自定义属性配置相关逻辑


  //打开SKU自定义弹窗
  const [attributeConfigModalVisible, setAttributeConfigModalVisible] = useState(false);


  //暂存默认值 用于回传自定义SKU部分
  const [customSKUAttributeConfigs, setCustomSKUAttributeConfigs] = useState<any[]>([
    // {	
    //   is_custom_attribute:true, //区分是否是自定义SKU属性
    //   product_base_attribute_id:3,//时间戳ID
    //   product_base_attribute_name: "产地",
      
    //   product_category_id:1, //分类id  product_category.product_category_id
    //   product_category_name: "手机",
      
    //   product_category_brand_id: 1,//品牌id product_category_brand.product_category_brand_id
    //   brand_name: "Apple",
      
    //   product_spu_id:1,  //spu Id   product_spu.product_spu_id
    //   product_spu_name:'iphone 16',
      
    //   options:[
    //     {
    //       product_category_base_attribute_option_id:1,
    //       option_name:'America'
    //     }
    //   ]
      
      
    // }
  ]);

  //当前自定义SKU属性配置 弹窗表单使用
  const [currentAttributeConfig, setCurrentAttributeConfig] = useState<CustomAttributeConfig>({
    attribute_name: '',
    attribute_values: ['']
  });

  //是否选择了品牌
  const [selectedBrandId, setSelectedBrandId] = useState<number | null>(null);

  // 属性
  const addCustomAttribute = () => {
    const newAttributes = [...customAttributes, {
      attribute_name: '',
      attribute_value: ''
    }];
    setCustomAttributes(newAttributes);

  };

  // 删除SKU自定义属性
  const deleteCustomAttribute = (index: number) => {
    const newAttributes = [...customAttributes];
    newAttributes.splice(index, 1);
    setCustomAttributes(newAttributes);
  };

  // 处理SKU自定义属性名称变化
  const handleAttributeNameChange = (value: string, index: number) => {
    setCustomAttributes(prevAttributes => {
      const newAttributes = [...prevAttributes];
      newAttributes[index] = {
        ...newAttributes[index],
        attribute_name: value
      };
      return newAttributes;
    });
  };

  // 处理SKU自定义属性值变化
  const handleAttributeValueChange = (value: string, index: number) => {
    setCustomAttributes(prevAttributes => {
      const newAttributes = [...prevAttributes];
      newAttributes[index] = {
        ...newAttributes[index],
        attribute_value: value
      };
      return newAttributes;
    });
  };

  // 打开属性配置弹窗
  const openAttributeConfigModal = () => {
    // 新建配置
    setCurrentAttributeConfig({
      attribute_name: '',
      attribute_values: ['']
    });
    setAttributeConfigModalVisible(true);
  };

  // 关闭属性配置弹窗
  const closeAttributeConfigModal = () => {
    setAttributeConfigModalVisible(false);
    setCurrentAttributeConfig({
      attribute_name: '',
      attribute_values: ['']
    });
  };

  // 处理属性名称变化
  const handleConfigAttributeNameChange = (value: string) => {
    setCurrentAttributeConfig(prev => ({
      ...prev,
      attribute_name: value
    }));
  };

  // 处理属性值变化
  const handleConfigAttributeValueChange = (value: string, index: number) => {
    setCurrentAttributeConfig(prev => {
      const newValues = [...prev.attribute_values];
      newValues[index] = value;
      return {
        ...prev,
        attribute_values: newValues
      };
    });
  };

  // 添加属性值输入框
  const addAttributeValue = () => {
    setCurrentAttributeConfig(prev => ({
      ...prev,
      attribute_values: [...prev.attribute_values, '']
    }));
  };

  // 删除属性值
  const deleteAttributeValue = (index: number) => {
    setCurrentAttributeConfig(prev => ({
      ...prev,
      attribute_values: prev.attribute_values.filter((_, i) => i !== index)
    }));
  };

  // 确认保存属性配置
  const confirmAttributeConfig = () => {
    if (!currentAttributeConfig.attribute_name.trim()) {
      message.error('请输入属性名称');
      return;
    }
    
    if (currentAttributeConfig.attribute_values.length === 0 || 
        currentAttributeConfig.attribute_values.every(value => !value.trim())) {
      message.error('请至少输入一个属性值');
      return;
    }

    const time = new Date().getTime();


    const newProductSpecs = {
      is_custom_attribute:true,
      product_base_attribute_id:time, 
      product_base_attribute_name: currentAttributeConfig.attribute_name,
      
      product_category_id:-1, 
      product_category_name: "",
      
      product_category_brand_id: -1,
      brand_name: "",
      
      product_spu_id:-1, 
      product_spu_name:'',

      options:currentAttributeConfig.attribute_values.map((item:any,index:number)=>{
        return {
          product_category_base_attribute_option_id:time+index+1,
          option_name:item
        }
      })
      
    };

    console.log(newProductSpecs,'newProductSpecs');
    

    setProductSpecs([...productSpecs,newProductSpecs]);




    // // 添加新配置
    setCustomSKUAttributeConfigs([...customSKUAttributeConfigs, newProductSpecs]);

    closeAttributeConfigModal();
  };

 

  // 删除SKU定义属性配置
  const deleteCustomAttributeConfig = (id: number) => {
    const newProductSpecs = productSpecs.filter((item:any) => item.product_base_attribute_id !== id);
    setProductSpecs(newProductSpecs);

    const newCustomSKUAttributeConfigs = customSKUAttributeConfigs.filter((item:any) => item.product_base_attribute_id !== id);
    setCustomSKUAttributeConfigs(newCustomSKUAttributeConfigs);

    
    
  };


  
  // SKU自定义属性配置相关逻辑  SKU自定义属性配置相关逻辑


  const mergedSpecs = useMemo(() => {
    
  
    if (formData?.customize_SKU_attribute&&customSKUAttributeConfigs.length>0) {
      return [...productSpecsesult, ...customSKUAttributeConfigs];
    }
  
    return productSpecsesult;
  }, [productSpecsesult, customSKUAttributeConfigs, formData?.customize_SKU_attribute]);

  useEffect(() => {

    if(mergedSpecs.length>0){
      console.log(222222,mergedSpecs);
      //用于编辑合并customSKUAttributeConfigs和productSpecs
      setProductSpecs(mergedSpecs);

    }
    
  }, [mergedSpecs]);

  //mouted初始化获取分类数据
  useEffect(() => {
    getProductCategoryAllList().then((res) => {
      console.log(res, 'getProductCategoryAllList');
      if (res.code === 200) {
        const data = res.data || [];
        //格式化分类数据
        const options = transformToCascaderOptions(data);
        setCascaderOptions(options);

        // 查找第一条数据的最后一个节点路径
        const lastNodePath = findLastNodePath(data);
        if (lastNodePath.length > 0) {
          //编辑的时候设置默认分类
          // setSelectedCascaderValue(lastNodePath);

        }
      }
    });


  }, []);


  // 初始化表单数据 编辑回传
  useEffect(() => {
    // 如果有formData，则填充表单
    if (formData && cascaderOptions.length > 0) {
      // 设置表单值
      form.setFieldsValue({
        productTitle: formData.product_title,
        product_category_brand_id: formData.product_category_brand_id,
        product_spu_id: formData.product_spu_id,
      });

      // 如果有分类ID，查找完整路径并设置
      if (formData.product_category_id && cascaderOptions.length > 0) {
        const path = findPathById(cascaderOptions, formData.product_category_id);
        if (path) {
          setSelectedCascaderValue(path);
        }
      }
      // 如果有品牌ID，获取对应的SPU列表
      if (formData.product_category_brand_id) {
        //获取品牌
        getBrandList(formData.product_category_id);
        //获取spu
        getSpuList(formData.product_category_brand_id);
        //获取sku属性列表
        getOptionsList(formData.product_category_id, formData.product_category_brand_id);
        //设置选中的品牌ID
        setSelectedBrandId(formData.product_category_brand_id);
      }



      // 如果有图片列表，设置图片
      if (formData.product_media_list && formData.product_media_list.length > 0) {
        const images = formData.product_media_list.map((item, index) => ({
          uid: (item.id&& (item.id+'') ) || `-${index}`,
          file_id:item.id || null,
          name: `image-${index}.png`,
          status: 'done' as const,
          url: item.product_media_file_url,
          product_media_id:item.product_media_id || null
        })) as any[];
        console.log('images',images);
        
        setFileList(images);
      }

      //回传自定义属性
      if (formData.product_custom_attributes && formData.product_custom_attributes.length > 0) {
        //debugger
        setCustomAttributes(formData.product_custom_attributes);
      }

      // //回传sku自定义属性配置
      if (formData.customize_SKU_attribute && typeof formData.customize_SKU_attribute === 'string') {
        setCustomSKUAttributeConfigs(JSON.parse(formData.customize_SKU_attribute));
      }

     
      if (formData?.product_sku_values && formData.product_sku_values.length > 0) {
        // 从formData中提取规格值
        const specValues: { [key: number]: (string | number)[] } = {};
  
        formData.product_sku_values.forEach(product => {
          if (Array.isArray(product.specs)) {
            product.specs.forEach(spec => {
              const key = spec.product_base_attribute_id;
              // 如果当前 key 不存在则初始化为数组
              if (!specValues[key]) {
                specValues[key] = [];
              }
              // 如果值不存在就添加（去重）
              if (!specValues[key].includes(spec.value)) {
                specValues[key].push(spec.value);
              }
            });
          }
        });

        setSelectedSpecValues(specValues);
      }
      
    }
  }, [formData, cascaderOptions]);



 


  // 处理提交
  const handleSubmit = () => {
    //校验 category必填
    if (selectedCascaderValue.length === 0) {
      message.error('Please select a category');
      return;
    }
    //校验 Main Image必填
    if (fileList.length === 0) {
      message.error('Please upload at least one image');
      return;
    }


    //必须选择SKU组合
    const selectedSpecValuesKeys = Object.keys(selectedSpecValues);
    //debugger
    if (selectedSpecValuesKeys.length === 0) {
      message.error('Please select at least one specification');
      return;
    }

    if (selectedSpecValuesKeys.length > 0) {
      const selectedSpecValuesValues = Object.values(selectedSpecValues)
      .filter((item:any)=>item.length>0);
      if (selectedSpecValuesValues.length===0) {
        message.error('Please select at least one specification');
        return;
      }
    }




    //校验自定义属性 填了就校验
    if (customAttributes.length > 0) {
      if (customAttributes.some(item => item.attribute_name === '' || item.attribute_value === '')) {
        message.error('Please fill in all custom attribute names and values');
        return;
      }
    }

    form.validateFields().then(values => {


      //生成SKU组合
      const skuListCopy = generateSkuList();

      // console.log(JSON.stringify(skuListCopy), 'skuListCopy');

      // console.log(fileList,'fileList');
      
      // 构建提交数据
      const submitData = {
        ...values,
        //记录自定义SKU属性配置 后台记录JSON串自己解析
        customize_SKU_attribute: JSON.stringify(customSKUAttributeConfigs),
        //产品分类Id
        product_category_id: selectedCascaderValue[selectedCascaderValue.length - 1],
        //产品分类品牌Id
        product_category_brand_id: values.product_category_brand_id,
        //产品分类spuId
        product_spu_id: values.product_spu_id,
        //产品标题
        product_title: values.productTitle,
        //产品描述
        //产品图片
        product_media_list: fileList.map(file => ({
          product_id: null,
          product_media_type: (file as any).media_type || "images",  
          product_media_file_url: file.url,
          product_media_video_cover_id: null,
          file_id: (file as any).file_id || file.id,  
          product_media_id: file.product_media_id || null
        })),
        product_del_media_list:fileListDel,
        //产品规格选项（包含自定义属性配置）
        product_sku_values: skuListCopy,
        product_custom_attributes:customAttributes
      };

      console.log('Form values777777:', submitData);
      onNext && onNext(submitData);
    }).catch(err => {
      console.error('Validation failed:', err);
    });
  };


  return (
    <div className={styles['store-publish-product-step1']}>

      <br />
      <div className={styles['main-title']}>{t('StorePublishProductStep1.BasicInformation')}</div>
      <Form form={form} layout="vertical">
        {/* 产品类别 */}
        <div className={styles['section']}>
          <div className={styles['section-title']}>
            <span className={styles['required']}>*</span> {t('StorePublishProductStep1.ProductCategory')}
          </div>
          <div className={styles['category-input']}>
            <Cascader

              value={selectedCascaderValue.length > 0 ? selectedCascaderValue : undefined}
              options={cascaderOptions}
              disabled={formData?.product_id?true:false}
              expandTrigger="hover"
              displayRender={displayRender}
              onChange={handleCascaderChange}
              placeholder={t("StorePublishProductStepEdit1.PleaseSelectACategory")}
              className={styles['cascader-selector']}
              changeOnSelect={false}
              // 只允许选择叶子节点
              fieldNames={{ label: 'label', value: 'value', children: 'children' }}
              showSearch={{
                filter: (inputValue, path) =>
                  path.some(option =>
                    option.label.toLowerCase().includes(inputValue.toLowerCase())
                  ),
                matchInputWidth: true,
                limit: 10, // 限制最多展示多少个匹配项（可选）
              }}
            />
          </div>
        </div>

        {/* 主图 */}
        <div className={styles['section']}>
          <div className={styles['section-title']}>
            <span className={styles['required']}>*</span> {t("StorePublishProductStepEdit1.MainImage")}
          </div>
          <div className={styles['image-requirement']}>
            {t("StorePublishProductStepEdit1.ImageRequirements")}
          </div>

          <Upload {...ImageProps}>
            {t("StorePublishProductStepEdit1.Upload")}
          </Upload>

        </div>

        {/* 产品标题 */}
        <div className={styles['section']}>
          <div className={styles['section-title']}>
            <span className={styles['required']}>*</span> {t("StorePublishProductStepEdit1.ProductTitle")}
          </div>
          <Form.Item
            name="productTitle"
            rules={[{ required: true, message: 'Please enter product title' }]}
          >
            <Input placeholder={t('StorePublishProductStepEdit1.NoMoreThan30Words')} maxLength={100} />
          </Form.Item>
          {/* <div className={styles['word-count']}>0/30</div> */}
        </div>


        {/* 类别属性 */}
        <div className={styles['section']}>
          <div className={styles['section-title']}>
             {t("StorePublishProductStepEdit1.CategoryAttributes")}
          </div>
          <div className={styles['attributes-container']}>
            {/* <div className={styles['attribute-row']}>
              <div className={styles['attribute-label']}><span className={styles['required']}>*</span>Brand</div>
              <div className={styles['attribute-input']}>
                <Form.Item
                  name="product_category_brand_id"
                  rules={[{ required: true, message: 'Please select a brand' }]}
                >
                  <Select
                    placeholder="Please Select" 
                    disabled={brandList.length === 0 || formData?.product_id?true:false}
                    onChange={changeBrand}
                  >
                    {
                      brandList.map((item) => (
                        <Select.Option value={item.product_category_brand_id} key={item.product_category_brand_id}>
                          {item.brand_name}
                        </Select.Option>
                      ))
                    }
                  </Select>
                </Form.Item>
              </div>
            </div> */}

            {/* <div className={styles['attribute-row']}>
              <div className={styles['attribute-label']}>Spu</div>
              <div className={styles['attribute-input']}>
                <Form.Item
                  name="product_spu_id"
                >
                  <Select 
                    placeholder="Please Select" 
                    disabled={spuList.length === 0 || formData?.product_id?true:false}>
                    {
                      spuList.map((item) => (
                        <Select.Option value={item.product_spu_id} key={item.product_spu_id}>
                          {item.product_spu_name}
                        </Select.Option>
                      ))
                    }
                  </Select>
                </Form.Item>
              </div>
            </div> */}
        
            {

              productSpecs.map((item, index) => (
                <div className={styles['attribute-row']} key={index}>
                  <div className={styles['attribute-label']}>{item.product_base_attribute_name}</div>
                  <div className={styles['attribute-input']}>
                    <CheckboxGroup
                      disabled={formData?.product_id?true:false}
                      options={item.options.map((option: any) => ({
                        label: option.option_name,
                        value: option.option_name
                      }))}
                      value={selectedSpecValues[item.product_base_attribute_id] || []}
                      onChange={(values) => handleSpecChange(item.product_base_attribute_id, values)}
                    />
                    {
                      !formData?.product_id&&item.is_custom_attribute&&
                      <Button 
                        type="text" 
                        danger 
                        size="small"
                        onClick={() => deleteCustomAttributeConfig(item.product_base_attribute_id)}
                        style={{marginLeft: '8px'}}
                      >
                        {t('common.Delete')}
                      </Button>
                    }
                    
                  </div>
                </div>
              ))
            }

            {/* 自定义SKU属性配置selectedBrandId &&  */}
            {!formData?.product_id&& (
              <div style={{borderTop:"1px solid #E1E8E9",paddingTop:"20px"}}>
                <div className={styles['attribute-row']}>
                  {/* <div className={styles['attribute-label']}></div> */}
                  <div className={styles['attribute-input']}>
                    <Button 
                      type="primary"
                      onClick={() => openAttributeConfigModal()}
                      className={styles['add-config-btn']}
                    >
                      {t("StorePublishProductStepEdit1.AddCustomAttributes")}
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* 自定义SKU属性配置 */}


        <div className={styles['section']}>
          <div className={styles['section-title']}>
            {t('StorePublishProductStepEdit1.CustomAttributes')}
          </div>
          <div className={styles['custom-attributes-hint']}>
            {t('StorePublishProductStepEdit1.Craftsmanship')}
          </div>

          <div className={styles['custom-attributes-container']}>
            {
              customAttributes.map((item, index) => (
                <div className={styles['custom-attribute-row']} key={index}>
                  <Input
                    value={customAttributes[index].attribute_name}
                    placeholder={t('StorePublishProductStepEdit1.AttributeName')} 
                    className={styles['custom-attribute-input']}
                    onChange={(e) => handleAttributeNameChange(e.target.value, index)}
                  />
                  <div className={styles['attribute-colon']}>:</div>
                  <Input
                    value={customAttributes[index].attribute_value}
                    placeholder={t('StorePublishProductStepEdit1.AttributeValue')}
                    className={styles['custom-attribute-input']}
                    onChange={(e) => handleAttributeValueChange(e.target.value, index)}
                  />
                  <div 
                    className={styles['delete-btn']} 
                    onClick={() => deleteCustomAttribute(index)}
                    title="Delete attribute"
                  ></div>
                </div>
              ))
            }

            <Button 
              className={styles['add-attribute-btn']} 
              onClick={addCustomAttribute}
              icon={<PlusOutlined />}
            >
              {t('common.Add')}
            </Button>
          </div>
        </div>

        {/* 按钮区域 */}
        <div className={styles['button-container']}>
          {/* <Button
            className={styles['reset-button']}
            onClick={() => form.resetFields()}
          >
            Reset
          </Button> */}
          <Button
            type="primary"
            className={styles['next-button']}
            onClick={handleSubmit}
          >
            {t('common.Next')}
          </Button>
        </div>
      </Form>

      {/* 添加预览Modal */}
      <Modal
        open={previewVisible}
        title={previewTitle}
        width={"80%"}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt={previewTitle} style={{ width: '100%' }} src={previewImage} />
      </Modal>

      {/* 自定义SKU属性配置弹窗 */}
      <Modal
        open={attributeConfigModalVisible}
        title={t('StorePublishProductStepEdit1.CustomAttributesConfig')}
        width={600}
        onCancel={closeAttributeConfigModal}
        footer={[
          <Button key="cancel" onClick={closeAttributeConfigModal}>
            {t('common.Cancel')}
          </Button>,
          <Button key="confirm" type="primary" onClick={confirmAttributeConfig}>
            {t('common.Confirm')}
          </Button>
        ]}
        className={styles['attribute-config-modal-wrapper']}
      > 
      
        <div className={styles['attribute-config-modal']}>
          {/* 属性名称 */}
          <div className={styles['config-section']}>
            <div className={styles['config-label']}>
              <span>*</span> {t('StorePublishProductStepEdit1.AttributeName')}
            </div>
            <Input
              value={currentAttributeConfig.attribute_name}
              placeholder={t('StorePublishProductStepEdit1.AttributeName')}
              onChange={(e) => handleConfigAttributeNameChange(e.target.value)}
              className={styles['config-input']}
            />
          </div>

          {/* 属性值 */}
          <div className={styles['config-section']}>
            <div className={styles['config-label']}>
              <span>*</span> {t("StorePublishProductStepEdit1.AttributeValue")}
            </div>
            {currentAttributeConfig.attribute_values.map((value, index) => (
              <div key={index} style={{display:"flex", marginBottom:"10px"}}>
                <Input
                  value={value}
                  placeholder={t("StorePublishProductStepEdit1.AttributeValue")}
                  onChange={(e) => handleConfigAttributeValueChange(e.target.value, index)}
                  className={styles['value-input']}
                />
                <Button 
                  type="text" 
                  danger 
                  onClick={() => deleteAttributeValue(index)}
                  className={styles['delete-value-btn']}
                >
                  {t('common.Delete')}
                </Button>
              </div>
            ))}
            <Button 
              type="primary"
              style={{backgroundColor:"#2AAD61",boxShadow:"none"}}
              onClick={addAttributeValue}
            >
              {t('StorePublishProductStepEdit1.AddAttributeValues')}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default StorePublishProductStep1; 